import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { LoaderFormQuestion } from "./loader";
import "./styles.scss";
import { ICreateHubSpotForm, IHubSpotFormProps } from "./types";
import { useIsInView } from "../../../hooks/useIsInView";
import { isClientSideRendering } from "../../../helpers/rendererType";

export const createHubSpotForm = (settings: ICreateHubSpotForm) => {
  window.hbspt.forms.create({
    formId: settings.hubSpotFormId,
    onFormSubmitted: settings.onFormSubmitted,
    onBeforeFormSubmit: settings.onBeforeFormSubmit,
    portalId: settings.hubSpotPortalId,
    target: `#${settings.containerId}`,
  });
};

const HubSpotForm: React.FC<IHubSpotFormProps> = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const containerId = `hubspot-form-${props.index}`;

  const { ref, isInView } = useIsInView();

  if (isClientSideRendering()) {
    const [scriptLoaded, setScriptLoaded] = useState(
      typeof window.hbspt !== "undefined",
    );

    useEffect(() => {
      if (isInView && !scriptLoaded) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
        const scriptjs = require("scriptjs"); // Prevent build errors on the server as we only need it on the front-end
        const scriptUrl = "https://js.hsforms.net/forms/v2.js"; // This library is a beast - 117kb! So we want to lazy load it

        scriptjs.get(scriptUrl, () => {
          setScriptLoaded(true);
          createHubSpotForm({
            hubSpotPortalId: props.hubSpotPortalId,
            containerId,
            hubSpotFormId: props.hubSpotFormId,
            onBeforeFormSubmit: () => {
              if (props.onBeforeFormSubmit) {
                props.onBeforeFormSubmit();
              }
            },
            onFormSubmitted: () => {
              if (props.onFormSubmitted) {
                props.onFormSubmitted();
              }
            },
          });
        });
      }
    }, [isInView, scriptLoaded]);
  }

  return (
    <div
      ref={ref}
      id={containerId}
      className={classNames("hubspot-form", {
        "hubspot-form--betterV2": props.betterV2,
      })}
      data-testid="hubspot-form"
    >
      <div
        data-testid="loading-component"
        role="alert"
        aria-live="polite"
        aria-busy="true"
      >
        <p hidden>Loading...</p>
        <LoaderFormQuestion numberOfQuestions={props.numberOfQuestions || 3} />
      </div>
    </div>
  );
};

export { HubSpotForm };
